import React, { memo, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Typography } from '@mui/material'
import tw from 'twin.macro'
import { ChatMajor, ChecklistAlternateMajor, QuestionMarkMajor } from '@shopify/polaris-icons'
import { Button } from 'src/components/shared/Button'
import { Settings } from 'src/components/settings/Settings'
import { show as showIntercom } from '@intercom/messenger-js-sdk'
import { useMediaQueries } from 'src/hooks/useMediaQueries'
import { getPartner } from 'src/selectors/partner'

const ClientHomePageHeaderComponent = () => {
  const partner = useSelector(getPartner)

  const { isMobile, isDesktopOrTablet } = useMediaQueries()

  const handleGetHelp = useCallback(() => {
    showIntercom()
  }, [])

  return (
    <div css={tw`w-full shadow fixed z-50`}>
      <div css={tw`bg-primary-700 w-full h-16 p-4 top-0 flex justify-between items-center`}>
        <img src={partner?.logoUrl} css={tw`h-[28px]`} />
        <div css={tw`flex-row flex gap-2`}>
          <Button
            className={tw`w-[120px] px-3`}
            rightIcon={
              isMobile && <QuestionMarkMajor css={tw`fill-shades-0`} width={20} height={20} />
            }
            leftIcon={
              isDesktopOrTablet && <ChatMajor css={tw`fill-shades-0`} width={20} height={20} />
            }
            onClick={handleGetHelp}
            color={isDesktopOrTablet ? 'dark' : 'primary'}
            size="medium"
          >
            Get Help
          </Button>
          <Settings flow="client" />
        </div>
      </div>
      <div css={tw`bg-primary-100 w-full h-9 flex items-center justify-center flex-row`}>
        <ChecklistAlternateMajor width={20} />
        <Typography css={tw`ml-2`} variant="caption" fontWeight={600}>
          Contractor's onboarding
        </Typography>
      </div>
    </div>
  )
}

export const ClientHomePageHeader = memo(ClientHomePageHeaderComponent)
